const GET_COOKIE_BY_NAME = (cookieName) => {
  // Retrieve cookie data by name
  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  let cookieValue = null;

  cookies.forEach((cookie) => {
    const cookieParts = cookie.split("=");
    const name = cookieParts[0];
    const value = cookieParts[1];
    if (name === cookieName) {
      cookieValue = decodeURIComponent(value);
    }
  });

  if (cookieValue == null) {
    return "";
  } else {
    return JSON.parse(atob(cookieValue));
  }
};
const GET_ALL_COOKIE = () => {
  // Retrieve all cookie data
  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  const cookieData = {};

  cookies.forEach((cookie) => {
    const cookieParts = cookie.split("=");
    const name = cookieParts[0];
    const value = cookieParts[1];
    cookieData[name] = decodeURIComponent(value);
  });

  console.log("All Cookie Data:", cookieData);
};
const SET_COOKIE = (cookieName, cookieData) => {
  // Set expiry time to 1 month from now
  const expiryDate = new Date();
  expiryDate.setMonth(expiryDate.getMonth() + 1);

  // Serialize cookie data
  const serializedData = btoa(JSON.stringify(cookieData));

  // Set the cookie
  document.cookie = `${cookieName}=${serializedData}; expires=${expiryDate.toUTCString()}; path=/`;

  // Redirect or perform any other actions after login
  // Example: window.location.href = "/dashboard";
};

const REMOVE_COOKIE_BY_NAME = (cookieName) => {
  // Set the expiry date of the cookie to a past time to remove it
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
const REMOVE_ALL_COOKIE = () => {
  // Get all cookies
  const cookies = document.cookie.split(";");
  // Iterate through each cookie and set its expiry date to a past time
  cookies.forEach((cookie) => {
    const cookieParts = cookie.split("=");
    const cookieName = cookieParts[0].trim();
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });

  // Redirect or perform any other actions after logout
  // Example: window.location.href = "/";
};

// ---------------
const COOKIE_CONSTANTS = {
  LOGIN: "LOGIN",
  ROLE_SELECTION: "ROLE_SELECTION",
  USER: "userData",
};
// --------------
export {
  COOKIE_CONSTANTS,
  GET_COOKIE_BY_NAME,
  GET_ALL_COOKIE,
  SET_COOKIE,
  REMOVE_COOKIE_BY_NAME,
  REMOVE_ALL_COOKIE,
};
